var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigscreen",style:({
    transform: ("scale(" + _vm.scalesNum + ") translate(-50%,-50%)"),
    '-webkit-transform': ("scale(" + _vm.scalesNum + ") translate(-50%,-50%)"),
    '-moz-transform': ("scale(" + _vm.scalesNum + ") translate(-50%,-50%)"),
    '-o-transform': ("scale(" + _vm.scalesNum + ") translate(-50%,-50%)"),
    '-ms-transform': ("scale(" + _vm.scalesNum + ") translate(-50%,-50%)"),
    'width': (_vm.width + "px"),
    'height': (_vm.height + "px"),
  })},[_c('router-view'),(_vm.showAlert)?_c('div',{staticClass:"alert",style:({
      position: 'fixed',
      right: '50px',
      top: '0px',
      width: (_vm.alertWidth + "px"),
      height: (_vm.alertHeight + "px"),
      zIndex: 999,
      transform: ("scale(" + _vm.alertScale + ")"),
      transformOrigin: 'top right'
    })},[_c('router-link',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","text-decoration":"none"},attrs:{"to":{
        name: 'BigScreen6_newPage',
        params: {
          classificationParams: {
            register_number: _vm.data.register_number,
            vElevatorCode: _vm.data.v_elevator_code,
            v_building_id: _vm.data.v_building_id,
            event_id: _vm.data.event_id,
            v_address: _vm.data.v_address,
          },
        },
      }}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/bigscreen/alert.gif")}}),_c('div',{style:({
        textAlign: 'center',
        marginTop: (_vm.alertNameMarginTop + "px"),
        fontSize: (_vm.alertNameFontSize + "px"),
        color: '#ff0000',
        fontWeight: 'bold',
        lineHeight: 1.4
      })},[_vm._v(_vm._s(_vm.data.v_address))])])],1):_vm._e(),_c('audio',{ref:"alarmAudio",on:{"ended":_vm.onAudioEnded}},[_vm._v(" Your browser does not support the audio element. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }